import React from "react";
import UpcomingEventItem from "./UpcomingEventItem";
import SkeletonLoader from "./SkeletonLoader";

const UpcomingEvents = ({ events, onEventClick }) => {
  return (
    <aside className="bg-[#f5f8f5] rounded-lg shadow-lg p-4 md:p-6 w-full max-w-screen-lg mx-auto">
      <h3 className="text-lg md:text-2xl font-bold text-[#2bbae6] mb-4 md:mb-6 font-big-shoulders text-center">
        Upcoming Events
      </h3>
      <div className="flex flex-col space-y-4">
        {events.length === 0 ? (
          <>
            <SkeletonLoader height="h-20" margin="mb-4" />
            <SkeletonLoader height="h-20" margin="mb-4" />
            <SkeletonLoader height="h-20" margin="mb-4" />
          </>
        ) : (
          events.map((event, index) => (
            <UpcomingEventItem
              key={event.id}
              title={event.title}
              description={event.description}
              image={event.imageUrl}
              index={index}
              onClick={() => onEventClick(event)}
            />
          ))
        )}
      </div>
    </aside>
  );
};

export default UpcomingEvents;
